"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unauthed = Unauthed;
exports.createSearchParams = createSearchParams;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
var _common = require("./common.js");
function createSearchParams(ssoUrlRealm, ssoUrlApp, ssoUrlPath) {
  const search = new URLSearchParams();
  if (ssoUrlRealm) search.append('realm', ssoUrlRealm);
  if (ssoUrlApp) search.append('app', ssoUrlApp);
  if (ssoUrlPath) search.append('path', ssoUrlPath);
  const searchString = search.toString();
  return searchString.length ? `?${searchString}` : '';
}

/**
 * Unauthenticated Account Tray component.
 *
 * @param {Object} props React props
 * @param {string} props.signInHeading Sign in heading
 * @param {string} props.signInContent Sign in content
 * @param {string} props.signInLabel Sign in label
 * @param {string} props.createAccountHeading Create account heading
 * @param {string} props.createAccountContent Create account content
 * @param {string} props.createAccountLabel Create account label
 * @param {string} props.customerNumberLabel Customer Number label
 * @param {string} props.ssoUrlPath sso url path
 * @param {string} props.ssoUrlApp sso url app
 * @param {string} props.ssoUrlRealm sso url realm
 * @param {string} props.ssoUrl ssourl
 * @param {object} props.menus Menus with links
 * @param {function} props.closeTray Close menu click handler
 * @returns {React.ReactElement} Unauther account tray
 * @public
 */
function Unauthed({
  signInLabel,
  signInHeading,
  signInContent,
  createAccountLabel,
  createAccountContent,
  createAccountHeading,
  ssoUrl,
  ssoUrlPath,
  ssoUrlApp,
  ssoUrlRealm,
  menus,
  closeTray,
  accountTrayRef
}) {
  const searchParams = createSearchParams(ssoUrlRealm, ssoUrlApp, ssoUrlPath);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "unauthed-account-tray"
  }, /*#__PURE__*/_react.default.createElement(_common.Caret, null), /*#__PURE__*/_react.default.createElement(_common.Flyout, {
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement(_closeButton.default, {
    onClose: () => closeTray(accountTrayRef)
  }), signInContent && /*#__PURE__*/_react.default.createElement(_common.AccountInfoContainer, null, /*#__PURE__*/_react.default.createElement(_common.AccountSectionHeading, null, signInHeading), /*#__PURE__*/_react.default.createElement("div", null, signInContent), /*#__PURE__*/_react.default.createElement(_common.AccountSectionLinkContainer, null, /*#__PURE__*/_react.default.createElement(_common.AccountSectionLink, (0, _extends2.default)({
    href: `${ssoUrl}${searchParams}`
  }, _patternLibraryUtils.tracking.create('sign_in_link', true, false)), signInLabel))), createAccountContent && /*#__PURE__*/_react.default.createElement(_common.AccountInfoContainer, null, /*#__PURE__*/_react.default.createElement(_common.AccountSectionHeading, null, createAccountHeading), /*#__PURE__*/_react.default.createElement("div", null, createAccountContent), /*#__PURE__*/_react.default.createElement(_common.AccountSectionLinkContainer, null, /*#__PURE__*/_react.default.createElement(_common.AccountSectionLink, (0, _extends2.default)({
    href: `${ssoUrl}/account/create${searchParams}`
  }, _patternLibraryUtils.tracking.create('create_account_link', true, false)), createAccountLabel))), menus?.map(({
    menuTitle,
    menuItems
  }, i) => {
    return /*#__PURE__*/_react.default.createElement(_common.AccountMenus, {
      key: i
    }, menuTitle && /*#__PURE__*/_react.default.createElement(_common.AccountSubSectionHeading, null, menuTitle), /*#__PURE__*/_react.default.createElement(_common.AccList, null, menuItems?.map(({
      title,
      href,
      _name
    }, j) => /*#__PURE__*/_react.default.createElement(_common.AccListItem, {
      key: j,
      "data-cy": "acc-list-item"
    }, /*#__PURE__*/_react.default.createElement(_common.AccDDA, (0, _extends2.default)({
      href: href
    }, _patternLibraryUtils.tracking.create(_name, true, false)), title)))));
  }), /*#__PURE__*/_react.default.createElement(_common.Stopper, {
    tabIndex: "0",
    onFocus: () => {
      closeTray(accountTrayRef);
    }
  })), /*#__PURE__*/_react.default.createElement(_common.Overlay, null));
}
Unauthed.propTypes = {
  signInHeading: _propTypes.default.string,
  signInContent: _propTypes.default.string,
  signInLabel: _propTypes.default.string,
  createAccountLabel: _propTypes.default.string,
  createAccountHeading: _propTypes.default.string,
  createAccountContent: _propTypes.default.string,
  ssoUrl: _propTypes.default.string,
  ssoUrlPath: _propTypes.default.string,
  ssoUrlApp: _propTypes.default.string,
  ssoUrlRealm: _propTypes.default.string,
  closeTray: _propTypes.default.func,
  accountTrayRef: _propTypes.default.object,
  menus: _propTypes.default.arrayOf(_propTypes.default.shape({
    menuTitle: _propTypes.default.string,
    menuItmes: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      href: _propTypes.default.string
    }))
  }))
};